module.exports = __webpack_public_path__ + "static/media/IMG_6052_2.efc25511.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/photos/IMG_6052_2.jpg
// module id = 208
// module chunks = 0